import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT, USER_LOADED, AUTH_ERROR } from '../actions/types';

const initialState = {
    token: null,
    isAuthenticated: false,
    loading: true,
    usuario: null
};

export default function authReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case USER_LOADED:
            return { ...state, isAuthenticated: true, loading: false, usuario: payload };
        case LOGIN_SUCCESS:
            return { ...state, isAuthenticated: true, loading: false, usuario: payload };
        case LOGIN_FAIL:
        case AUTH_ERROR:
        case LOGOUT:
            return { ...state, token: null, isAuthenticated: false, loading: false, usuario: null };
        default:
            return state;
    }
}
